import React from "react";

const AdminResults = () => {
  return <h2>Enter Student Results</h2>;
};

export default AdminResults;
